import { useEffect } from "react";

import { useSearchParams } from "react-router-dom-v5-compat";

export const useTimeoutSearchParam = (
  paramName: string,
  time: number = 5000
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get(paramName) === "cancelled") {
      const timer = setTimeout(() => {
        setSearchParams((searchParams) => {
          searchParams.delete(paramName);
          return searchParams;
        });
      }, time);
      return () => clearTimeout(timer);
    }
  }, [searchParams]);
  const param = searchParams.get(paramName);
  return param;
};
